import React, { useCallback, useEffect, useState } from 'react';
import './NewQuotation.scss';
import { DataGrid, Form, LoadPanel, Menu, Popup } from 'devextreme-react';
import { ButtonItem, ButtonOptions, GroupItem, Item, Label, RequiredRule } from 'devextreme-react/cjs/form';
import { Column } from 'devextreme-react/cjs/data-grid';
import AddQuoteRider from '../AddQuoteRider/AddQuoteRider';
import GlobalParams from '../../helpers/GlobalParams';
import notify from 'devextreme/ui/notify';
import axios from 'axios';
import ApiHelper from '../../helpers/ApiHelper';
import group_bronchure_path from '../../templates/GROUP_C_WELFARE_FLYER_PDF.pdf';
import travel_bronchure_path from '../../templates/travel.pdf';
import welfare_bronchure_path from '../../templates/GROUP_C_WELFARE_FLYER_PDF.pdf';
import NewTraveler from '../NewTraveler/NewTraveler';

const subtractDay = (date) => {
  // Create a new Date object to avoid modifying the original date
  let newDate = new Date(date);

  // Subtract one day (1 day = 24 hours)
  newDate.setDate(newDate.getDate() - 1);

  return newDate;
}

const calculateAge = (birthDate) => {
  const currentDate = new Date();
  const birthDateObj = new Date(birthDate);

  let age = currentDate.getFullYear() - birthDateObj.getFullYear();

  // Check if the birthday has occurred for this year
  if (currentDate.getMonth() < birthDateObj.getMonth() ||
    (currentDate.getMonth() === birthDateObj.getMonth() && currentDate.getDate() < birthDateObj.getDate())) {
    age--;
  }

  return age;
};

const downloadBronchures = (download_path, download_filename) => {
  //let download_path = loan_term_top_up_template_path;
  //let download_filename = 'loan_term_extension_template.xlsx';
  // Fetch the file
  fetch(download_path)
    .then(response => response.blob()) // Convert the response to a Blob
    .then(blob => {
      // Convert the Blob to Base64
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => {
        // Create a temporary anchor element
        const anchor = document.createElement('a');
        anchor.href = reader.result; // Set the href to the Base64 data URL
        anchor.download = download_filename; // Set the filename for download
        anchor.click(); // Trigger the download
      };
    })
    .catch(error => console.error('Error fetching the file:', error));
}

const NewQuotation = ({ onClosePopup }) => {

  const [isNotLoggedIn, setIsNotLoggedIn] = useState(localStorage.getItem('email') === undefined);
  const [isLoading, setIsLoading] = useState(false);
  var default_form = {
    "currency": 1,
    "email": "",
    "mobile": "",
    "NatureOfBusiness": "",
    "ProductName": null,
    "CompanyName": "",
    "TotalMembers": 0,
    "AnnualSalary": 0,
    "PremiumRate": 0,
    "CoverFactor": 0,
    "SumAssured": 0,
    "DeathCoverPremium": 0,
    "RiderPremium": 0,
    "PHCFAmount": 0,
    "StampDuty": 0,
    "TotalPremium": 0,
    "FreeCoverLimit": 0,
  };
  const [PlanRiderAutomatic, setPlanRiderAutomatic] = useState([]);
  const [isFormLoaded, setIsFormLoaded] = useState(false);
  const [isTravelerFormLoaded, setIsTravelerFormLoaded] = useState(false);
  const [quotationStore, setQuoatationStore] = useState(default_form);
  const [popupRiderVisible, setPopupRiderVisible] = useState(false);
  const [popupTravelerVisible, setPopupTravelerVisible] = useState(false);
  const [ridersData, setRidersData] = useState([]);
  const [TotalMembers, setTotalMembers] = useState(0);
  const [DeathCoverBenefit, setDeathCoverBenefit] = useState(0);
  const [defaultRiderForm, setDefaultRiderForm] = useState({
    "Rider": null,
    "RiderOptions": null,
    "SalaryMultiplier": 0,
    "PercApplicable": 0,
    "BenefitLevel": 0,
    "SumAssured": 0,
    "PremiumRate": 0,
    "Premium": 0,
    "fixed_premium": 0
  });
  const [defaultTravelerForm, setDefaultTravelerForm] = useState({
    "TravelerName": '',
    "BirthDate": null,
    "Age": 0,
    "date_from": null,
    "date_to": null,
    "Country": ''
  });
  const [travelData, setTravelData] = useState([]);

  /////////visibility properties///////////// vsAge, vsBirthDate, vsTripDepDate vsNarration 
  //vsPackage vsTavelerName
  const [vsAddTravelData, setVsAddTravelData] = useState(false);
  const [vsTravelData, setVsTravelData] = useState(false);
  const [vsTavelerName, setVsTavelerName] = useState(false);
  const [vsPackage, setVsPackage] = useState(false);
  const [vsStartDate, setVsStartDate] = useState(false);
  const [vsEndDate, setVsEndDate] = useState(false);
  const [vsCurrency, setVsCurrency] = useState(false);
  const [vsTotalMembers, setVsTotalMembers] = useState(false);
  const [vsAnnualSalary, setVsAnnualSalarye] = useState(false);
  const [vsCoverFactor, setVsCoverFactor] = useState(false);
  const [vsSumAssured, setVsSumAssured] = useState(false);
  const [vsRidersData, setVsRidersData] = useState(false);
  const [vsTotalPremium, setVsTotalPremium] = useState(false);
  const [vsAddRider, setVsAddRider] = useState(false);
  const [vsAge, setVsAge] = useState(false);
  const [vsAverageAge, setVsAverageAge] = useState(false);
  const [vsBirthDate, setVsBirthDate] = useState(false);
  const [vsTripDepDate, setVsTripDepDate] = useState(false);
  const [vsTripReturnDate, setVsTripReturnDate] = useState(false);
  const [vsCountry, setVsCountry] = useState(false);
  const [vsNarration, setVsNarration] = useState(false);
  const [vsNatureOfEmployment, setVsNatureOfEmployment] = useState(false);

  const DefaultForm = () => {

    setVsPackage(false);
    setVsNarration(false);
    setVsAge(false);
    setVsStartDate(false);
    setVsEndDate(false);
    setVsCurrency(false);
    setVsTotalMembers(false);
    setVsAnnualSalarye(false);
    setVsCoverFactor(false);
    setVsSumAssured(false);
    setVsRidersData(false);
    setVsTotalPremium(false);
    setVsAddRider(false);
    setVsBirthDate(false);
    setVsAverageAge(false);

    setVsAddTravelData(false);
    setVsTravelData(false);

    setVsTripDepDate(false);
    setVsTripReturnDate(false);

    setVsCountry(false);
  }
  ////////end of visibility properties////// 
  const ProductChanged = (product) => {
    setVsNarration(true);
    if (product === "2") {//group comprehensive plan
      setVsAverageAge(true);
      setVsStartDate(true);
      setVsEndDate(true);
      setVsCurrency(true);
      setVsTotalMembers(true);
      setVsAnnualSalarye(true);
      setVsCoverFactor(true);
      setVsSumAssured(true);
      //setVsRidersData(true);
      //setVsTotalPremium(true);
      //setVsAddRider(true);
    }
    if (product === "11") {//Travel Insurance
      //setVsBirthDate(true);
      //setVsAge(true);
      //setVsTripDepDate(true);
      //setVsTripReturnDate(true);
      //setVsCountry(true);
      setVsAddTravelData(true);
      setVsTravelData(true);
    }
    if (product === "12") {//Group Welfare
      setVsPackage(true);
      setVsStartDate(true);
      setVsEndDate(true);
      setVsTotalMembers(true);
    }
  }

  //const [vsRiders, setVsRiders] = useState(false);
  const ClearForm = () => {
    setRidersData([]);
    setQuoatationStore(default_form);
  };

  const hideRiderPopup = () => {
    setIsFormLoaded(false);
    setPopupRiderVisible(false);
  };

  const hideTravelerPopup = () => {
    setIsTravelerFormLoaded(false);
    setPopupTravelerVisible(false);
  };

  const emptyItemConfig = {
    colSpan: 2,
    itemType: 'empty',
  };

  const fetchPlanRider = async (schemeId) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + "product-rider-classes?scheme_id=" + schemeId,
        GlobalParams.bearerToken
      );

      setIsLoading(false);
      //setClaimTpyesStore(result.data);
    } catch (error) {
      // Handle error, e.g., show an error message
      console.log(error);
      setIsLoading(false);
      //setClaimTpyesStore([]);
      //notify(error.response.data.message,5000);
    }
  }

  const CalcTotalPremium = async () => {
    // Ensure DeathCoverPremium is updated
    await CalcDeathCoverPrem();

    console.log("Death Cover Period: " + quotationStore.DeathCoverPremium);
    // Calculate totalPremium using updated values
    let TotalPremium = parseFloat(quotationStore.RiderPremium) + parseFloat(quotationStore.DeathCoverPremium);
    let PHCFAmount = (0.25 / 100) * TotalPremium;

    // Update state with TotalPremium and PHCFAmount
    await new Promise(resolve => {
      setQuoatationStore((state) => {
        return ({ ...state, TotalPremium: TotalPremium })
      });
      resolve();
    });

    await new Promise(resolve => {
      setQuoatationStore((state) => {
        return ({ ...state, PHCFAmount: PHCFAmount })
      });
      resolve();
    });
  }

  const CalculateSumAssured = async () => {
    // Calculate SumAssured
    let sa = parseFloat(quotationStore.CoverFactor) * parseFloat(quotationStore.AnnualSalary) *
      parseFloat(quotationStore.TotalMembers);

    // Update state with SumAssured
    await new Promise(resolve => {
      setQuoatationStore((state) => {
        return ({ ...state, SumAssured: sa })
      });
      resolve();
    });
  }

  const CalcDeathCoverPrem = async () => {
    // Calculate DeathCoverPremium
    let DeathCoverPremium = (parseFloat(quotationStore.PremiumRate) / 1000) * (parseFloat(quotationStore.SumAssured));

    // Update state with DeathCoverPremium
    await new Promise(resolve => {
      setQuoatationStore((state) => {
        return ({ ...state, DeathCoverPremium: DeathCoverPremium })
      });
      resolve();
    });
  }

  const doAllCalculations = async () => {
    // Perform all calculations sequentially
    await CalculateSumAssured();
    await CalcDeathCoverPrem();
    await CalcTotalPremium();
  }

  const performAllCalculations = async () => {
    // Calculate SumAssured
    let SumAssured = parseFloat(quotationStore.CoverFactor) * parseFloat(quotationStore.AnnualSalary);

    // Calculate DeathCoverPremium
    let DeathCoverPremium = (parseFloat(quotationStore.PremiumRate) / 1000) * SumAssured;

    // Calculate totalPremium
    let TotalPremium = parseFloat(quotationStore.RiderPremium) + DeathCoverPremium;

    let StampDuty = parseFloat(quotationStore.StampDuty);

    // Calculate PHCFAmount
    let PHCFAmount = (0.25 / 100) * TotalPremium;

    TotalPremium = TotalPremium + PHCFAmount + StampDuty;

    setDeathCoverBenefit(SumAssured);
    // Update state with all calculated values
    setQuoatationStore((state) => {
      return {
        ...state,
        SumAssured: SumAssured,
        DeathCoverPremium: DeathCoverPremium,
        TotalPremium: TotalPremium,
        PHCFAmount: PHCFAmount
      };
    });
  }

  // Call performAllCalculations when needed

  const performRiderCalculations = async (tmp_ridersData) => {
    let rider_premium = 0;
    //TODO - calculate the rider premium
    tmp_ridersData.forEach((element) => {
      // Calculate rider premium based on element properties
      rider_premium += parseFloat(element.Premium.toString().replace(/,/g, ''));
    });

    //calculate the new total premium
    console.log(quotationStore.DeathCoverPremium);
    let total_premium = parseFloat(quotationStore.DeathCoverPremium.toString().replace(/,/g, '')) + rider_premium;
    let StampDuty = parseFloat(quotationStore.StampDuty.toString().replace(/,/g, ''));
    //calculate the new phcf
    let PHCFAmount = (0.25 / 100) * total_premium;

    total_premium = total_premium + PHCFAmount + StampDuty;
    //calculate the new total...

    setQuoatationStore((state) => {
      return ({ ...state, RiderPremium: rider_premium })
    });
    setQuoatationStore((state) => {
      return ({ ...state, PHCFAmount: PHCFAmount })
    });
    setQuoatationStore((state) => {
      return ({ ...state, TotalPremium: total_premium })
    });
  }


  // Call doAllCalculations when needed

  const postQuotation = async (post_data) => {
    try {
      let tmp_ridersData = ridersData || [];

      let isLoggedIn = (localStorage.getItem('isLoggedIn') === '1');
      let is_random_client = 0;
      if (!isLoggedIn) {
        is_random_client = 1;
      }
      let cover_period = 365;



      //let 
      //.replace(/[,!]/g, '')
      let QuotationData = {
        'currency': post_data.currency,
        'cover_period': cover_period,
        'is_random_client': is_random_client,
        'mobile_number': post_data.mobile,
        'email': post_data.email,
        'NatureOfBusiness': post_data.NatureOfBusiness,
        'product_name': post_data.ProductName,
        'start_date': post_data.date_from,
        'end_date': post_data.date_to,
        'Quotation_name': post_data.CompanyName,
        'total_members': post_data.TotalMembers,
        'total_salary': post_data.AnnualSalary,
        'salary_multiplier': post_data.CoverFactor,
        'fixed_sum_assured': post_data.SumAssured,
        'premium_rate': post_data.PremiumRate,
        'phcf_amount': post_data.PHCFAmount,
        //'unit_rate': post_data.CompanyName,
        'stamp_duty': post_data.StampDuty,
        'FreeCoverLimit': post_data.FreeCoverLimit,
        'total_risk_premium': post_data.TotalPremium,
        'death_cover_premium': post_data.DeathCoverPremium,
        'rider_premium': post_data.RiderPremium,
        'broker_id': GlobalParams.IntermediaryId,
        'portal_user_id': GlobalParams.ContactPersonId,
        'PackageId': post_data.PackageId,
        'Avg_Age': post_data.Avg_Age
      }

      let combinedHashmap = tmp_ridersData.length > 0 ? tmp_ridersData.reduce((acc, obj, index) => {
        // Assuming the formdata is the key 'key' in each object
        Object.keys(obj).forEach(key => {
          let tmp_key = "";
          if (key === 'Rider') { tmp_key = 'rider_code'; }
          if (key === 'RiderOptions') {
            //1, 2, 3 :: is benefit fixed, is % of sum assured, is salary based respectively.
            tmp_key = 'distribution_type';//the logic is quite robust here....
          }
          if (key === 'SalaryMultiplier') { tmp_key = 'salary_multiplier'; }
          if (key === 'PercApplicable') { tmp_key = 'perc_payable'; }
          if (key === 'BenefitLevel') { tmp_key = 'benefit_level'; }
          if (key === 'FreeCoverLimit') { tmp_key = 'FreeCoverLimit'; }
          if (key === 'SumAssured') {
            tmp_key = 'rider_benefit';
          }
          if (key === 'PremiumRate') { tmp_key = 'premium_rate'; }
          if (key === 'Premium') {
            tmp_key = 'premium_amount';
          }
          if (tmp_key !== "") {
            acc[`riders[${index}][${tmp_key}]`] = obj[key];
          }
        });
        return acc;
      }, { ...QuotationData }) : QuotationData;

      //combinedHashmap = { ...combinedHashmap, ...filesData }
      let tmp_TravelerData = travelData;
      combinedHashmap = tmp_TravelerData.length > 0 ?
        tmp_TravelerData.reduce((acc, obj, index) => {
          // Iterate over each key in the current dependent's object
          Object.keys(obj).forEach(key => {
            // Use a computed property name to create the combined key
            acc[`traveler[${index}][${key}]`] = obj[key];
          });
          // Return the accumulator for the next iteration
          return acc;
        }, { ...QuotationData })
        :
        { ...QuotationData };

      console.log(combinedHashmap);

      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "create-quotation",
        combinedHashmap,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      //console.log(result.data.data.claim_request_id);
      //if (result.status === 200 ) {
      setIsLoading(false);
      //clear_form();

      notify(result.data.message, 'success', 5000);
      //postAutomate(result.data.data.claim_request_id);

      //TODO - After Testing Revert..
      ClearForm();
      DefaultForm();
      onClosePopup();
      // }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };


  const doSave = useCallback(async (e) => {
    e.preventDefault();


    //TODO - check if all automatic benefits are added...
    // Initialize an array to store missing mandatory files
    //const missingFiles = [];

    // Iterate through plan_rider to check if automatic riders are uploaded
    // PlanRiderAutomatic.forEach(document => {
    //   if (document.IsAutomatic) {
    //     //rider_code
    //     const rider_code = document.rider_code;
    //     //TODO - iterate ridersData and check if that rider code exists...
    //     let riderFound = false;
    //     ridersData.forEach(rider => {
    //       if (rider.Rider === rider_code) {
    //         riderFound = true;
    //       }
    //     });
    //     if (!riderFound) {
    //       missingFiles.push(document.rider_name);
    //     }
    //   }
    // });

    // If any missing mandatory files are found, display notifications
    // if (missingFiles.length > 0) {
    //   const missingFilesMessage = missingFiles.join(', ');
    //   notify({
    //     message: `The following mandatory benefits are not selected: ${missingFilesMessage}`,
    //     position: {
    //       my: 'center top',
    //       at: 'center top'
    //     }
    //   }, 'error', 10000);
    //   return;
    // }

    setIsLoading(true);
    console.log("guys are here");
    postQuotation(quotationStore);
    // Close the pop-up after the search is performed
  }, [quotationStore]);


  const onMenuItemClick = (cellInfo, item) => {

    if (item === 'Edit') {
      //cellInfo.data.CommissionReference
      //ridersData
      //TODO-Display the riders form having populated the data
      //1. display the AddQuoteRider and pass the 

      setDefaultRiderForm({
        "Rider": cellInfo.data.Rider,
        "RiderOptions": cellInfo.data.RiderOptions,
        "SalaryMultiplier": cellInfo.data.SalaryMultiplier,
        "PercApplicable": cellInfo.data.PercApplicable,
        "BenefitLevel": cellInfo.data.BenefitLevel,
        "SumAssured": cellInfo.data.SumAssured,
        "PremiumRate": cellInfo.data.PremiumRate,
        "Premium": cellInfo.data.Premium,
        "fixed_premium": cellInfo.data.fixed_premium
      });
      setIsFormLoaded(true);
      setPopupRiderVisible(true);




    } else if (item === 'Delete') {
      //Remove the ridersData store and then re-calculate the rider premium
      console.log(cellInfo);
      let rowIndex = cellInfo.rowIndex;
      let tmp_ridersData = [...ridersData];
      tmp_ridersData.splice(rowIndex, 1);
      setRidersData(tmp_ridersData);
      performRiderCalculations(tmp_ridersData);
    }

  };
  const menuItems = [
    { text: 'Edit', icon: 'edit' },
    { text: 'Delete', icon: 'trash' }
  ];
  const actionColumnTemplate = (cellInfo) => {
    return (
      <div>
        <Menu
          onItemClick={(e) => onMenuItemClick(cellInfo, e.itemData.text)}
        >
          <Item
            text=" "
            items={menuItems}
          >
          </Item>
        </Menu>
      </div>
    );
  };

  const getDateAfterOneYear = (inputDate) => {
    // Parse the input date string to create a Date object
    const date = new Date(inputDate);

    // Check if the input date is January 1st
    const isJanFirst = date.getMonth() === 0 && date.getDate() === 1;

    // Add one year to the date
    date.setFullYear(date.getFullYear() + 1);

    // Adjust the date if it was January 1st
    if (isJanFirst) {
      date.setDate(date.getDate() - 1);
    }

    // Format the date as YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
  };



  return (
    <div>
      <div >
        {isLoading && <LoadPanel visible={true} />}
        {/*popupTravelerVisible*/}
        <div>
          {popupTravelerVisible && <Popup
            visible={popupTravelerVisible}
            onHiding={hideTravelerPopup}
            title="ADD TRAVELER"

          >
            <NewTraveler onClosePopup={(e) => {
              setTravelData((prevData) => {

                // Ensure prevData is initialized as an array
                const tmp_TravelerData = Array.isArray(prevData) ? [...prevData, e] : [e];
                console.log(tmp_TravelerData);


                return tmp_TravelerData;
              });
              hideTravelerPopup();
            }} defaultForm={defaultTravelerForm}
            />
          </Popup>}
        </div>

        {/*popupRiderVisible*/}
        <div>
          {popupRiderVisible && <Popup
            visible={popupRiderVisible}
            onHiding={hideRiderPopup}
            title="ADD RIDER"

          >
            <AddQuoteRider onClosePopup={(e) => {
              setRidersData((prevData) => {

                // Ensure prevData is initialized as an array
                const tmp_ridersData = Array.isArray(prevData) ? [...prevData, e] : [e];
                console.log(tmp_ridersData);

                performRiderCalculations(tmp_ridersData);


                return tmp_ridersData;
              });
              hideRiderPopup();
            }} TotalMembers={TotalMembers} DeathCoverBenefit={DeathCoverBenefit}
              defaultForm={defaultRiderForm}
            />
          </Popup>}
        </div>
        <br></br>
        <section className="row">
          {/* div and form of the download the bronchures*/}
          <div className="col-md-3">
            <Form>
              <GroupItem colCount={1} caption="Download Bronchures">
                <ButtonItem
                  colSpan={1}
                >
                  <ButtonOptions
                    type='danger'
                    width={300}
                    text="TRAVEL INSURANCE"
                    icon='download'
                    onClick={
                      () => {
                        //download the bronchure..
                        downloadBronchures(travel_bronchure_path, 'travel.pdf');
                      }
                    }
                  />
                </ButtonItem>
                <ButtonItem
                  colSpan={1}
                >
                  <ButtonOptions
                    type='danger'
                    width={300}
                    text="GLICO GROUP WELFARE"
                    icon='download'
                    onClick={
                      () => {
                        //download the bronchure..
                        //downloadBronchures(welfare_bronchure_path, 'welfare.pdf');
                        notify({
                          message: `Bronchure is Currently Unavailable`,
                          position: {
                            my: 'center top',
                            at: 'center top'
                          }
                        }, 'error', 5000);
                      }
                    }
                  />
                </ButtonItem>
                <ButtonItem
                  colSpan={1}
                >
                  <ButtonOptions
                    type='danger'
                    width={300}
                    text="GLICO GROUP COMPREHENSIVE PLAN"
                    icon='download'
                    onClick={
                      () => {
                        //download the bronchure..
                        downloadBronchures(travel_bronchure_path, 'travel.pdf');
                      }
                    }
                  />
                </ButtonItem>
              </GroupItem>
            </Form>
          </div>
          <div className="col-md-9">
            <form onSubmit={doSave}>
              <Form
                formData={quotationStore}>
                {/* Create new Group with 3 buttons to download the products bronchurs */}

                <GroupItem colCount={2} caption="Application Form">
                  <Item
                    dataField="email"
                    editorOptions={
                      {
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            setQuoatationStore((state) => {
                              return ({ ...state, email: e.value })
                            });
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Email is required" />
                    <Label text='Email' location="top" />
                  </Item>

                  <Item
                    dataField="mobile"
                    editorOptions={
                      {
                        mask: '233 000-000-000',
                        maskRules: { X: /[02-9]/ },
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            setQuoatationStore((state) => {
                              return ({ ...state, mobile: e.value })
                            });
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Mobile Number is required" />
                    <Label text='Mobile Number' location="top" />
                  </Item>

                  <Item
                    dataField="CompanyName"
                    editorType="dxTextBox"
                    editorOptions={
                      {
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            console.log(e.value);
                            setQuoatationStore((state) => {
                              return ({ ...state, CompanyName: e.value })
                            });
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Company Name is required" /> 
                    <Label text='Name of Company / Association' location="top" />
                  </Item>

                  <Item
                    dataField="NatureOfBusiness"
                    editorType="dxTextBox"
                    editorOptions={
                      {
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            console.log(e.value);
                            setQuoatationStore((state) => {
                              return ({ ...state, NatureOfBusiness: e.value })
                            });
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Nature of Business is required" /> 
                    <Label text='Nature of Business' location="top" />
                  </Item>

                  {/* <Item
                dataField="industry"
                editorOptions={
                  {
                    onValueChanged: (e) => {
                      if (e.value !== undefined && e.value !== null && e.value !== '') {
                         setQuoatationStore((state) => {
                           return ({ ...state, industry: e.value })
                         });
                      }
                    }
                  }
                }
              >
                <RequiredRule message="Industry is required" />
                <Label text='Industry' />
              </Item> */}
                  <Item {...emptyItemConfig} />
                  <Item colSpan={2}>
                    <div style={{ color: 'red', fontWeight: 'bold', padding: '10px 0' }}>
                      ***Please ensure that you have downloaded and read the brochure on the selected product.
                    </div>
                  </Item>

                  <Item
                    colSpan={2}
                    dataField="ProductName"
                    editorType="dxLookup"
                    editorOptions={
                      {
                        dataSource: GlobalParams.QuoteProductClasses,
                        displayExpr: "PortalDescription",
                        valueExpr: "class_code",
                        searchEnabled: false,
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            console.log(e.value);
                            DefaultForm();
                            ProductChanged(e.value);
                            setQuoatationStore((state) => {
                              return ({ ...state, ProductName: e.value })
                            });

                            //TODO - Filter the Plan Rider Config....
                            let tmpPlanRiderAutomatic = GlobalParams.ProductRider.filter(plan_rider =>
                              (plan_rider.plan_code === e.value && plan_rider.IsAutomatic === "1"));
                            console.log(tmpPlanRiderAutomatic);
                            setPlanRiderAutomatic(tmpPlanRiderAutomatic);

                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Product is required" />
                    <Label text='Product' location="top"/>
                  </Item>

                  <Item
                    dataField="NatureOfEmployment"
                    visible={vsNatureOfEmployment}
                    editorType="dxTextBox"
                    editorOptions={
                      {
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            console.log(e.value);
                            setQuoatationStore((state) => {
                              return ({ ...state, NatureOfEmployment: e.value })
                            });
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Nature of Employment is required" /> 
                    <Label text='Nature of Employment' location="top" />
                  </Item>

                  <Item
                    dataField="PackageId"
                    visible={vsPackage}
                    editorType="dxLookup"
                    editorOptions={
                      {
                        dataSource: GlobalParams.ProductPackages,
                        displayExpr: "description",
                        valueExpr: "id",
                        searchEnabled: false,
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            setQuoatationStore((state) => {
                              return ({ ...state, PackageId: e.value })
                            });
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Plan is required" />
                    <Label text='Plan' location="top"/>
                  </Item>

                  <Item
                    dataField="TravelerName"
                    visible={vsTavelerName}
                    editorType="dxTextBox"
                    editorOptions={
                      {
                        readOnly: false,
                        // onValueChanged: (e) => {
                        //   if (e.value !== undefined && e.value !== null && e.value !== '') {
                        //     // console.log(e.value);
                        //     // setQuoatationStore((state) => {
                        //     //   return ({ ...state, RiderPremium: e.value })
                        //     // });
                        //   }
                        // }
                      }
                    }
                  >
                    <RequiredRule message="Traveler's is required" />
                    <Label text="Traveler's Name" location="top"/>
                  </Item>

                  <Item
                    dataField="BirthDate"
                    visible={vsBirthDate}
                    editorType="dxDateBox"
                    editorOptions={
                      {
                        displayFormat: "dd/MM/yyyy",
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            console.log(e.value);
                            const age = calculateAge(e.value);
                            setQuoatationStore((state) => {
                              return ({ ...state, BirthDate: e.value })
                            });
                            setQuoatationStore((state) => {
                              return ({ ...state, Age: age })
                            });
                            // setQuoatationStore((state) => {
                            //   return ({ ...state, date_to: getDateAfterOneYear(e.value) })
                            // });

                          }
                        }
                      }
                    }
                  >
                    <RequiredRule text="Date of Birth is Required is required" />
                    <Label text='Date of Birth' location="top"/>
                  </Item>

                  <Item
                    dataField="Age"
                    visible={vsAge}
                    editorType="dxNumberBox"
                    editorOptions={
                      {
                        readOnly: true,
                        format: ",##0.###",
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            console.log(e.value);
                            // setQuoatationStore((state) => {
                            //   return ({ ...state, Age: e.value })
                            // });
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Age is required" />
                    <Label text='Age' location="top"/>
                  </Item>


                  <Item
                    dataField="date_from"
                    visible={vsTripDepDate}
                    editorType="dxDateBox"
                    editorOptions={
                      {
                        displayFormat: "dd/MM/yyyy",
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            console.log(e.value);
                            //calculate the age of client..

                            setQuoatationStore((state) => {
                              return ({ ...state, date_from: e.value })
                            });
                            // setQuoatationStore((state) => {
                            //return ({ ...state, date_to: getDateAfterOneYear(e.value) })
                            // });

                          }
                        }
                      }
                    }
                  >
                    <RequiredRule text="Trip Departure Date is Required is required" />
                    <Label text='Trip Departure Date' location="top"/>
                  </Item>



                  <Item
                    dataField="date_to"
                    visible={vsTripReturnDate}
                    editorType="dxDateBox"
                    editorOptions={
                      {
                        displayFormat: "dd/MM/yyyy",
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            console.log(e.value);
                            //get the date from one year
                            setQuoatationStore((state) => {
                              return ({ ...state, date_to: e.value })
                            });
                            // setQuoatationStore((state) => {
                            //   return ({ ...state, date_to: getDateAfterOneYear(e.value) })
                            // });

                          }
                        }
                      }
                    }
                  >
                    <RequiredRule text="Trip Return Date is Required is required" />
                    <Label text='Trip Return Date' location="top"/>
                  </Item>

                  <Item
                    dataField="Country"
                    visible={vsCountry}
                    editorOptions={
                      {
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            setQuoatationStore((state) => {
                              //return ({ ...state, email: e.value })
                            });
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Country is required" />
                    <Label text='Country' location="top"/>
                  </Item>

                  <Item
                    dataField="date_from"
                    visible={vsStartDate}
                    editorType="dxDateBox"
                    editorOptions={
                      {
                        displayFormat: "dd/MM/yyyy",
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            console.log(e.value);
                            //get the date from one year
                            setQuoatationStore((state) => {
                              return ({ ...state, date_from: e.value })
                            });

                            setQuoatationStore((state) => {
                              return ({ ...state, date_to: subtractDay(getDateAfterOneYear(e.value)) })
                            });

                          }
                        }
                      }
                    }
                  >
                    <RequiredRule text="Start Date is Required is required" />
                    <Label text='Start Date' location="top"/>
                  </Item>

                  <Item
                    dataField="date_to"
                    visible={vsEndDate}
                    editorType="dxDateBox"
                    editorOptions={
                      {
                        displayFormat: "dd/MM/yyyy",
                        readOnly: true,
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            // setQuoatationStore((state) => {
                            //   return ({ ...state, date_to: e.value })
                            // });
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule text="End Date is Required is required" />
                    <Label text='End Date' location="top"/>
                  </Item>
                  {/*Currencies */}
                  <Item
                    dataField="currency"
                    visible={vsCurrency}
                    editorType="dxLookup"
                    editorOptions={
                      {
                        dataSource: GlobalParams.Currencies,
                        displayExpr: "description",
                        valueExpr: "id",
                        searchEnabled: false,
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            setQuoatationStore((state) => {
                              return ({ ...state, currency: e.value })
                            });
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Currency is required" />
                    <Label text='Currency' location="top"/>
                  </Item>

                  <Item
                    dataField="TotalMembers"
                    visible={vsTotalMembers}
                    editorType="dxNumberBox"
                    editorOptions={
                      {
                        format: ",##0.###",
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            console.log(e.value);
                            setTotalMembers(e.value);
                            setQuoatationStore((state) => {
                              return ({ ...state, TotalMembers: e.value })
                            });
                            performAllCalculations();
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Total Members is required" />
                    <Label text='Total Members' location="top"/>
                  </Item>

                  <Item
                    dataField="AnnualSalary"
                    visible={vsAnnualSalary}
                    editorType="dxNumberBox"
                    editorOptions={
                      {
                        format: ",##0.###",
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            console.log(e.value);
                            setQuoatationStore((state) => {
                              return ({ ...state, AnnualSalary: e.value })
                            });
                            performAllCalculations();
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Total Annual Salary is required" />
                    <Label text='Total Annual Salary' location="top"/>
                  </Item>

                  <Item
                    dataField="Avg_Age"
                    visible={vsAverageAge}
                    editorType="dxNumberBox"
                    editorOptions={
                      {
                        format: ",##0.###",
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            console.log(e.value);
                            setQuoatationStore((state) => {
                              return ({ ...state, Avg_Age: e.value })
                            });
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Average Age is required" />
                    <Label text='Average Age' location="top"/>
                  </Item>


                  <Item
                    dataField="CoverFactor"
                    visible={vsCoverFactor}
                    editorType="dxNumberBox"
                    editorOptions={
                      {
                        format: ",##0.###",
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            console.log(e.value);
                            setQuoatationStore((state) => {
                              return ({ ...state, CoverFactor: e.value })
                            });
                            performAllCalculations();
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Salary Multiplier is required" />
                    <Label text='Salary Multiplier' location="top"/>
                  </Item>

                  <Item
                    dataField="SumAssured"
                    visible={vsSumAssured}
                    editorType="dxNumberBox"
                    editorOptions={
                      {
                        format: ",##0.###",
                        readOnly: true,
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            console.log(e.value);
                            setQuoatationStore((state) => {
                              return ({ ...state, SumAssured: e.value })
                            });
                            performAllCalculations();
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Sum Assured is required" />
                    <Label text='Sum Assured' location="top"/>
                  </Item>

                  <Item
                    dataField="PremiumRate"
                    visible={false}
                    editorType="dxNumberBox"
                    editorOptions={
                      {
                        format: ",##0.###",
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            console.log(e.value);
                            setQuoatationStore((state) => {
                              return ({ ...state, PremiumRate: e.value })
                            });
                            performAllCalculations();
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Premium Rate is required" />
                    <Label text='Premium Rate' location="top"/>
                  </Item>

                  <Item
                    dataField="DeathCoverPremium"
                    visible={false}
                    editorType="dxNumberBox"
                    editorOptions={
                      {
                        format: ",##0.###",
                        readOnly: true,
                        // onValueChanged: (e) => {
                        //   if (e.value !== undefined && e.value !== null && e.value !== '') {
                        //     // console.log(e.value);
                        //     // setQuoatationStore((state) => {
                        //     //   return ({ ...state, DeathCoverPremium: e.value })
                        //     // });
                        //   }
                        // }
                      }
                    }
                  >
                    <RequiredRule message="Death Cover Premium is required" />
                    <Label text='Death Cover Premium' location="top"/>
                  </Item>

                  <Item
                    dataField="RiderPremium"
                    visible={false}
                    editorType="dxNumberBox"
                    editorOptions={
                      {
                        format: ",##0.###",
                        readOnly: true,
                        // onValueChanged: (e) => {
                        //   if (e.value !== undefined && e.value !== null && e.value !== '') {
                        //     // console.log(e.value);
                        //     // setQuoatationStore((state) => {
                        //     //   return ({ ...state, RiderPremium: e.value })
                        //     // });
                        //   }
                        // }
                      }
                    }
                  >
                    <RequiredRule message="Rider Premium is required" />
                    <Label text='Rider Premium' location="top"/>
                  </Item>

                  <Item
                    dataField="PHCFAmount"
                    visible={false}
                    editorType="dxNumberBox"
                    editorOptions={
                      {
                        format: ",##0.###",
                        readOnly: true,
                        // onValueChanged: (e) => {
                        //   if (e.value !== undefined && e.value !== null && e.value !== '') {
                        //     console.log(e.value);
                        //     setQuoatationStore((state) => {
                        //       return ({ ...state, PHCFAmount: e.value })
                        //     });
                        //   }
                        // }
                      }
                    }
                  >
                    <RequiredRule message="PHCF Amount is required" />
                    <Label text='PHCF Amount' location="top"/>
                  </Item>

                  <Item
                    dataField="StampDuty"
                    visible={false}
                    editorType="dxNumberBox"
                    editorOptions={
                      {
                        format: ",##0.###",
                        readOnly: true
                        // onValueChanged: (e) => {
                        //   if (e.value !== undefined && e.value !== null && e.value !== '') {
                        //     console.log(e.value);
                        //     setQuoatationStore((state) => {
                        //       return ({ ...state, StampDuty: e.value })
                        //     });
                        //   }
                        // }
                      }
                    }
                  >
                    <RequiredRule message="Stamp Duty is required" />
                    <Label text='Stamp Duty' location="top"/>
                  </Item>

                  <Item
                    dataField="TotalPremium"
                    visible={vsTotalPremium}
                    editorType="dxNumberBox"
                    editorOptions={
                      {
                        format: ",##0.###",
                        readOnly: true,
                        // onValueChanged: (e) => {
                        //   if (e.value !== undefined && e.value !== null && e.value !== '') {
                        //     // console.log(e.value);
                        //     // setQuoatationStore((state) => {
                        //     //   return ({ ...state, TotalPremium: e.value })
                        //     // });
                        //   }
                        // }
                      }
                    }
                  >
                    <RequiredRule message="Total Premium is required" />
                    <Label text='Total Premium' location="top"/>
                  </Item>

                  {/* {} */}
                  <Item
                    dataField="FreeCoverLimit"
                    editorType="dxNumberBox"
                    visible={false}
                    editorOptions={
                      {
                        format: ",##0.###",
                        readOnly: false,
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            console.log(e.value);
                            setQuoatationStore((state) => {
                              return ({ ...state, FreeCoverLimit: e.value })
                            });
                          }
                        }
                      }
                    }
                  >
                    <RequiredRule message="Free Cover Limit is required" />
                    <Label text='Free Cover Limit' location="top"/>
                  </Item>




                  <Item {...emptyItemConfig} />

                  {/*Grid for travel data*/}
                  <ButtonItem
                    colSpan={2}
                    visible={vsAddTravelData}
                  >
                    <ButtonOptions
                      type='danger'
                      width={180}
                      text="Add Traveler"
                      icon='plus'
                      onClick={
                        () => {
                          setDefaultTravelerForm({
                            "TravelerName": '',
                            "BirthDate": null,
                            "Age": 0,
                            "date_from": null,
                            "date_to": null,
                            "Country": ''
                          });
                          setIsTravelerFormLoaded(true);
                          setPopupTravelerVisible(true);
                        }
                      }
                    />
                  </ButtonItem>


                  <Item colSpan={2}>
                    <DataGrid
                      width={'100%'}
                      visible={vsTravelData}
                      dataSource={travelData}
                      wordWrapEnabled={true}
                      columnHidingEnabled={false}
                      allowColumnReordering={true}
                      editing={{
                        allowDeleting: false, // Enable deleting
                        // Other editing options if needed
                      }}
                    >
                      <Column
                        dataField="TravelerName"
                      >
                      </Column>
                      <Column
                        dataField="BirthDate"
                      >
                      </Column>
                      <Column
                        dataField="Age"
                      >
                      </Column>
                      <Column
                        dataField="date_from"
                      >
                      </Column>
                      <Column
                        dataField="date_to"
                      >
                      </Column>
                      <Column
                        dataField="Country"
                      >
                      </Column>
                    </DataGrid>
                  </Item>

                  {/*Add the data grid for riders.. */}
                  <ButtonItem
                    colSpan={2}
                    visible={vsAddRider}
                  >
                    <ButtonOptions
                      type='danger'
                      width={180}
                      text="Add Benefit"
                      icon='plus'
                      onClick={
                        () => {
                          setDefaultRiderForm({
                            "Rider": null,
                            "RiderOptions": null,
                            "SalaryMultiplier": 0,
                            "PercApplicable": 0,
                            "BenefitLevel": 0,
                            "SumAssured": 0,
                            "PremiumRate": 0,
                            "Premium": 0,
                            "fixed_premium": 0
                          });
                          setIsFormLoaded(true);
                          setPopupRiderVisible(true);
                        }
                      }
                    />
                  </ButtonItem>


                  <Item colSpan={2}>
                    <DataGrid
                      width={'100%'}
                      visible={vsRidersData}
                      dataSource={ridersData}
                      wordWrapEnabled={true}
                      columnHidingEnabled={false}
                      allowColumnReordering={true}
                      editing={{
                        allowDeleting: false, // Enable deleting
                        // Other editing options if needed
                      }}
                    >
                      <Column width={50} caption="" cellRender={actionColumnTemplate} />
                      <Column
                        dataField="Rider"
                        caption='Rider'
                        lookup={{
                          dataSource: GlobalParams.AllRiders,
                          displayExpr: "description",
                          valueExpr: "rider_code"
                        }}
                      >
                      </Column>
                      <Column
                        dataField="RiderOptions"
                        lookup={{
                          dataSource: GlobalParams.riderOptions,
                          displayExpr: "description",
                          valueExpr: "id"
                        }}
                        visible={false}
                      >
                      </Column>
                      <Column
                        dataField="SalaryMultiplier"
                        visible={false}
                      >
                      </Column>
                      <Column
                        dataField="PercApplicable"
                        visible={false}
                      >
                      </Column>
                      <Column
                        dataField="BenefitLevel"
                        visible={false}
                      >
                      </Column>
                      {/* <Column
                    dataField="SumAssured"
                    caption='SumAssured' >
                  </Column>
                  <Column
                    dataField="PremiumRate"
                  >
                  </Column>
                  <Column
                    dataField="Premium"
                    caption='Premium' >
                  </Column> */}
                    </DataGrid>
                  </Item>

                  <Item {...emptyItemConfig} />


                  {/*Add Narration */}
                  <Item
                    colSpan={2}
                    dataField="Narration"
                    editorType="dxTextArea"
                    visible={vsNarration}
                    editorOptions={
                      {
                        readOnly: false,
                        onValueChanged: (e) => {
                          if (e.value !== undefined && e.value !== null && e.value !== '') {
                            console.log(e.value);
                            setQuoatationStore((state) => {
                              return ({ ...state, Narration: e.value })
                            });
                          }
                        }
                      }
                    }
                  >
                    {/* <RequiredRule message="Narration is required" /> */}
                    <Label text='Addition Information' location="top"/>
                  </Item>
                  <Item {...emptyItemConfig} />
                  <Item
                    colSpan={1}
                    itemType='empty'
                  >
                  </Item>
                  <ButtonItem horizontalAlignment='right'>
                    <ButtonOptions
                      type='default'
                      text="SUBMIT APPLICATION"
                      icon='save'
                      useSubmitBehavior={true}
                    />
                  </ButtonItem>
                </GroupItem>

                

              </Form>
            </form>
          </div>

          {/* <h5 style={{ color: '#2E86C1', fontWeight: 'bold' }}>GET A QUOTE</h5> */}

        </section>
        <br></br>

      </div>
    </div>
  );

}
export default NewQuotation;